import Eth from "../../../../assets/icons/eth.svg";
import Bnb from "../../../../assets/icons/networks/bnb.png";
import Polygon from "../../../../assets/icons/networks/polygon.png";
import xoc from "../../../../assets/icons/networks/xoc.png";
import ezETH from "../../../../assets/icons/networks/ezeth.png";
import radar from "../../../../assets/icons/networks/radar.png";
import alETH from "../../../../assets/icons/networks/aleth.png";
import edexa from "../../../../assets/icons/Logo_X.svg";

function EthIcon() {
  // return <div className="bg-violet-600 size-7 rounded-2xl"></div>;
  return <img src={Eth} alt="Eth" />;
}
function BnbIcon() {
  // return <div className="bg-violet-600 size-7 rounded-2xl"></div>;
  return <img src={Bnb} width={22} alt="Bnb" />;
}
function PolygonIcon() {
  // return <div className="bg-violet-600 size-7 rounded-2xl"></div>;
  return <img src={Polygon} width={22} alt="Polygon" />;
}
function XocIcon() {
  return <img src={xoc} width={22} alt="XOC" />;
}
function RadarIcon() {
  return <img src={radar} width={22} alt="RADAR" />;
}
function EzethIcon() {
  return <img src={ezETH} width={22} alt="EzETH" />;
}
function AlEthIcon() {
  return <img src={alETH} width={22} alt="alEth" />;
}

function EdexaIcon() {
  return (
    <div className="flex items-center justify-center w-6 h-6 rounded-full overflow-hidden bg-white">
      <img 
        src={edexa} 
        width={18} 
        height={18} 
        alt="edexa" 
      />
    </div>
  );
}

// export {EthIcon,BnbIcon,PolygonIcon}
export {
  EthIcon,
  BnbIcon,
  PolygonIcon,
  XocIcon,
  RadarIcon,
  EzethIcon,
  AlEthIcon,
  EdexaIcon,
};
